
(function () {
	'use strict';

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

    var configModule = angular.module('configModule', ['customeDirectivesModule']);
    //config for datepicker
    configModule.config(['uibDatepickerPopupConfig', function (uibDatepickerPopupConfig) {
        var dateFormat = window.globalDateFormat && window.globalDateFormat.dateFormat ? window.globalDateFormat.dateFormat : "dd.MM.yyyy";
        var timeFormat = window.globalDateFormat && window.globalDateFormat.timeFormat ? window.globalDateFormat.timeFormat : "h:mm tt";
        uibDatepickerPopupConfig.datepickerPopup = dateFormat;
        //uibDatepickerConfig.config.dateFormat = dateFormat;
        //uibDatepickerConfig.config.timeFormat = timeFormat
    }]);
	configModule.factory('loginRecoverer', ['$q', '$templateCache', function ($q, $templateCache) {
        var loginRecoverer = {
            responseError: function (response) {
                if (response.status == 401 && !HandbookConfiguration.AnonymousMode == "True") {
                        window.location = "/Account/Login";
                    }
                    return $q.reject(response);
            },
			request: function (request) {
				var language = user.language ? user.language : getCookie(LANGUAGECULTURE);
				language = !language ? 'no' : language;
                if ($templateCache.get(request.url) === undefined) { // cache miss
                    var linkedElement = '?';
                    // Item is not in $templateCache so add our query string
                    if (request && request.url && request.url.includes('?')) {
                        linkedElement = '&';
                    }
					request.url = request.url + linkedElement + 'v=' + HandbookConfiguration.ApplicationVersion + language;
                }
                return request;
            }
        };
        return loginRecoverer;
    }]);

    configModule.config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('loginRecoverer');
    }]);

    configModule.config(['$uibTooltipProvider', function ($tooltipProvider) {
        $tooltipProvider.setTriggers({
            'mouseenter': 'mouseleave',
            'click': 'click',
            'focus': 'blur',
            'never': 'mouseleave' // <- This ensures the tooltip will go away on mouseleave
        });
    }]);

})();